module.exports = __webpack_public_path__ + "img/专用集成电源 (2).c8df81d0.jpg";